import { useQuery } from '@tanstack/vue-query'

import { operatorPermissionQuery } from '@mp/api/sdpMerchant/OperatorController.ts'
import { computed } from 'vue'

export function usePermissions() {
  const { data } = useQuery({
    queryKey: ['get/permissions'],
    queryFn: () => operatorPermissionQuery(),
    refetchOnWindowFocus: false,
  })

  const memberRoles = computed(() => data.value?.data?.memberRoles)
  const operatorRoles = computed(() => data.value?.data?.operatorRoles)
  const permissions = computed(() => {
    return data.value?.data?.permissions
  })

  // 是否包含该权限码
  function isAuthorized(code: string[] | string) {
    if (Array.isArray(code))
      return permissions.value?.some((permission: string) => code.includes(permission))
    return permissions.value?.includes(code)
  }

  return {
    memberRoles,
    operatorRoles,
    permissions,
    isAuthorized,
  }
}
